import scrollMonitor from 'scrollmonitor'
import slick from 'slick-carousel'
import has from 'lodash/has'
import qs from 'query-string'
import { requestTimeout, getHeaderOffset } from '../util'

const $slider = $('.advantages-slider ul')
const $iconSlider = $('.advantages-icon-slider')
const $grid = $('.advantages-grid')

const handleActiveGridItem = (index = 0) => {
  $('.advantages-grid button.grid-item--active').removeClass('grid-item--active')
  $(`.advantages-grid button[data-index=${index}]`).addClass('grid-item--active')

  $('.advantages-grid').toggleClass('advantages-grid--default', index === 0)
  $('.advantages-icon-slider').toggleClass('advantages-grid--default', index === 0)
}

const urlParams = qs.parse(window.location.search)
const startIndex = has(urlParams, 'start') ? urlParams.start : 0

handleActiveGridItem(startIndex)

if (has(urlParams, 'start')) {
  requestTimeout(() => {
    const offset = getHeaderOffset()

    $.scrollTo($('.page-content-wrapper'), 250, { offset: -offset })
  }, 300)
}

const setupSlider = () => {
  $iconSlider.slick({
    fade: true,
    initialSlide: parseInt(startIndex),
    arrows: false
  })

  $slider.slick({
    dots: true,
    mobileFirst: true,
    initialSlide: parseInt(startIndex),
    asNavFor: $iconSlider,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dots: false
        }
      }
    ],
  })

  $slider.on('beforeChange', (e, slick, current, next) => {
    handleActiveGridItem(next)
  })

  $('.advantages-grid').on('click', 'button', e => {
    const index = $(e.currentTarget).data('index')

    $slider.slick('slickGoTo', index)
  })
}

const setupScroll = () => {
  const gridWatcher = scrollMonitor.create($grid.get(0))

  gridWatcher.fullyEnterViewport(() => {
    $grid.find('.grid__cell--hidden').sort(() => (Math.round(Math.random()) - 0.5)).each((index, el) => {
      const delay = (200 * (index + 1))

      requestTimeout(() => {
        $(el).removeClass('grid__cell--hidden')
      }, delay)
    })

    gridWatcher.destroy()
  })
}

export default {
  can: () => $('body').hasClass('page-advantages'),
  run: () => {
    setupSlider()
    setupScroll()
  }
}
